<template>
  <div>
    <v-navigation-drawer v-model="drawer" app>
      <v-card class="mx-auto" tile color="white">
        <v-img contain  :src="require('../assets/rotostop_logo.png')" height="63"></v-img>
      </v-card>
      <v-divider></v-divider>
      <v-list dense shaped>
        <template mplate v-for="(item, index) in listOfMenu">
          <template v-if="item.is_show && item.isSettings">
            <v-divider :key="`${index}_divider`"></v-divider>
            <v-subheader class="subtitle-2" :key="`${index}_settings`">{{ $t('message.layout.settings') }}</v-subheader>
          </template>
          <v-list-item :key="`${index}_list`" v-if="item.is_show && !item.hasChildren" :to="item.to">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-group v-else-if="item.is_show" :key="`${index}_children`" :prepend-icon="item.icon" append-icon="mdi-chevron-down">
            <template v-slot:activator>
              <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
            </template>
            <v-list-item v-for="subItem in item.children" class="ml-3" :key="subItem.title" :to="subItem.to">
              <v-list-item-action>
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ $t(subItem.title) }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app absolute :color="getEnvironmentColor" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer">
        <v-icon>menu</v-icon>
      </v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-menu transition="slide-x-transition" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>language</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item-group color="primary">
              <v-list-item
                v-for="(item, i) in langItem"
                :key="i" @click="changeLang(item.value)" id="select_lang"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-menu>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-chip class="ma-2" v-on="on" label color="primary" text-color="white">
            <v-avatar left>
              <v-icon>account_circle</v-icon>
            </v-avatar>{{ userDetails.name }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in items" :key="index" @click="menuActions(item.click)">
            <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <!-- SUPPORT LIST DISPLAY -->
    <v-dialog v-model="supportList.dialog" persistent max-width="800px" class="mt-0">
      <v-form ref="supportFields" onSubmit="return false;">
        <v-card>
          <v-card-title>
            {{ $t('message.common.addNew') }} {{ supportList.module }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-2">
            <v-col cols="12">
              <v-row>
                <v-text-field outlined hide-details ref="autoFocus" @keyup.enter="addNewListItem" v-model="supportList.text" :label="$t('message.customer.name')" :rules="$_requiredValidation"></v-text-field>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" id="deleteConfirm" @click="addNewListItem">{{ $t('message.common.save') }}</v-btn>
            <v-btn color="error" id="deleteClose" @click="closeListItemDialog">{{ $t('message.common.close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <!-- DELETE WARNING -->
    <v-dialog v-model="showDialog" persistent max-width="400px" class="mt-0">
      <v-card>
        <v-card-title>
          {{ $t('message.common.deleteConfirm') }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
          {{ $t('message.common.areYouSure') }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" id="deleteConfirm" :loading="loading" @click="isLocalDelete ? dialogOk() : confirmDelete()">{{ $t('message.common.yes') }}</v-btn>
          <v-btn color="primary" id="deleteClose" @click="showDialog = false">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Changes lost dialog -->
    <v-dialog v-model="getchangeLostDialog" persistent width="400">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title> {{ $t('message.common.warning') }} </v-card-title>
        <v-card-text class="pa-5">
          <h4>{{ $t('message.common.changes_saved') }}</h4>
          <h3 class="mt-2">{{ $t('message.common.are_you_navigate') }}</h3>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="confirmToChanges">{{ $t('message.common.yes') }} </v-btn>
          <v-btn color="error" @click="$store.commit('changeLostDialog', false)">{{ $t('message.common.no') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import menuList from './menus'
export default {
  data () {
    return {
      drawer: null,
      items: [
        { title: 'message.layout.logout', click: 'logout' }],
      listName: '',
      listDefault: false,
      loading: false
    }
  },
  computed: {
    getEnvironmentColor () {
      return process.env.VUE_APP_LAYOUT_COLOR
    },
    ...mapState(['showDialog', 'userDetails', 'deletePayload', 'supportList', 'isLocalDelete']),
    ...mapGetters(['getchangeLostDialog']),
    listOfMenu () {
      const list = this.$formatter.cloneVariable(menuList)
      const userRoleId = this.$store.state.userDetails.role_id
      const ifNotAdminRole = ['/dashboard', '/customers', '/users', '/w_h/stocks', '/orders', '/production_order/order', '/reports', '/deviations']
      list.forEach(x => {
        if (!ifNotAdminRole.includes(x.to)) {
          x.is_show = userRoleId === 1
          if (x.to === '/sharepoint' && userRoleId !== 1) x.is_show = false
          if (x.hasChildren) x.children.map(x => { x.is_show = userRoleId === 1 })
        } else x.is_show = true
      })
      return list
      // if (!this.getuserDetails.isadmin) {
      //   list.splice((list.length - 1), 1)
      //   return list
      // } else return list
    },
    cartItems () {
      return this.$store.state.cartItems
    },
    showDialog: {
      get () {
        return this.$store.state.showDialog
      },
      set (val) {
        if (!val) this.$store.commit('hideDialog')
      }
    },
    username () {
      if (this.$store.state.userDetails) {
        return this.$store.state.userDetails.email
      } else return 'Admin'
    },
    getURL () {
      const url = process.env.VUE_APP_URL
      return url.split('/api')[0]
    },
    langItem () {
      let language
      if (this.$i18n.locale === 'en') {
        language = [{ title: this.$t('message.common.norwegian'), value: 'no' }]
      } else if (this.$i18n.locale === 'no') {
        language = [{ title: this.$t('message.common.english'), value: 'en' }]
      }
      return language
    }
  },
  watch: {
    'supportList.dialog' (val) {
      if (val) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (this.$refs.autoFocus) {
              this.$refs.autoFocus.focus()
            }
          }, 300)
        })
      }
    }
  },
  mounted () {
    this.$eventBus.$on('loadingFalse', () => {
      this.loading = false
    })
  },
  methods: {
    confirmDelete () {
      this.loading = true
      const model = this.deletePayload
      if (model.getOnlyConfirmation) {
        this.$eventBus.$emit('deleteConfirmed', model)
      } else if (model.isSingle) {
        this.$store.dispatch('deleteSingleRecordHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('deleteHandler', model)
          .then(() => {
            this.$eventBus.$emit('deleteSuccess', model.module)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    menuActions (action) {
      switch (action) {
        case 'logout':
          this.$store.dispatch('logout')
          this.$router.push('/login')
          break
        case 'clear-od':
          this.clearOneDrive()
          break
        case 'user-profile':
          this.$router.push('/user_profile')
          break
        default:
          break
      }
    },
    clearOneDrive () {
      this.$_executeApi('post', 'onedrivesettings/clear_my_token', null)
        .then((response) => {
          if (response.data) {
            this.$router.push('/hse')
          }
        })
    },
    addNewListItem () {
      if (this.$refs.supportFields.validate()) {
        const model = { name: this.supportList.text, isactive: true }
        const url = this.supportList.module
        this.$_executeApi('post', `${url}`, model)
          .then((response) => {
            switch (this.supportList.module) {
              case this.USERROLES:
                this.$store.dispatch('getUserRoles')
                break
              case this.GROUPS:
                this.$store.dispatch('getGroups')
                break
              case this.PRODUCT_GROUPS:
                this.$store.dispatch('getProductGroups')
                break
              case this.TICKET_STATUS:
                this.$store.dispatch('getStatus')
                break
              case this.PRIORITY:
                this.$store.dispatch('getPriority')
                break
              case this.TYPE:
                this.$store.dispatch('getTypes')
                break
              case this.DEVIATION_LOCATIONS:
                this.$store.dispatch('getDeviationLocation')
                break
              case this.DEVIATION_CATEGORIES:
                this.$store.dispatch('getDeviationCategory')
                break
              case this.DEVIATION_STATUS:
                this.$store.dispatch('getDeviationStatus')
                break
              case this.CUSTOMER_PRIORITY:
                this.$store.dispatch('getCustomerPriority')
                break
              case this.CUSTOMER_INDUSTRY:
                this.$store.dispatch('getCustomerIndustry')
                break
              case this.CUSTOMER_SHIPMENT:
                this.$store.dispatch('getCustomerShipment')
                break
              case this.WAREHOUSE:
                this.$store.dispatch('getWarehouse')
                break
              default:
                break
            }
            this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: this.$t('message.common.addedSucess') })
            this.closeListItemDialog()
          })
      }
    },
    closeListItemDialog () {
      this.$store.commit('supportingList', { dialog: false })
      this.$refs.supportFields.reset()
      this.$refs.supportFields.resetValidation()
    },
    changeLang (language) {
      this.$i18n.locale = language
      this.$cookie.set('ROTOSTOP_locale', language)
    },
    confirmToChanges () {
      const route = this.$router.history.pending
      if (route) {
        this.changesLostHandler()
        this.$router.push(route.fullPath)
      } else {
        this.changesLostHandler()
      }
    },
    dialogOk () {
      this.$store.commit('dialogOk')
    },
    changesLostHandler () {
      this.$store.commit('isChangesMade', false)
      this.$store.commit('changeLostDialog', false)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('loadingFalse')
  }
}
</script>
<style>
  .image-auto-size .v-image__image--cover {
    background-size: auto !important;
  }
  .max-width-30-per {
    max-width: 30%;
  }
</style>
